import { useRoutes } from 'react-router-dom'

import { publicRoutes } from './publicRoutes'

export default function Routes() {
  return useRoutes([...publicRoutes])
}
